<template>
  <!-- show debtor, representative and client widget starts -->
  <b-row
    :class="customChange ? 'list-group-item' : ''"
  >
    <!-- solid color -->
    <b-col
      md="12"
      xl="12"
    >
      <b-card
        class="card-transaction"
        no-body
      >
        <b-overlay
          id="overlay-background-documents"
          :show="loader && identitiesLoader"
          variant="dark"
          opacity="0.85"
          blur="2px"
          rounded="sm"
          spinner-variant="primary"
          spinner-medium
        >
          <b-card-header>
            <b-card-title>{{ $t('DEBTIA_CLIENT') }}</b-card-title>
            <!-- <drag-links
            :parent="6"
            :side="side"
            :custom-change="customChange"
          /> -->
            <b-card-title class="text-primary">
              <b-button
                id="add-case-btn"
                v-b-modal.modal-change-client
                variant="primary"
              >
                <span class="text-nowrap">{{ $t('DEBTIA_CHANGE') }}</span>
              </b-button>
            </b-card-title>
          </b-card-header>
          <b-card-body
            v-if="client"
            class="casedetails-card-body"
          >
            <div
              class="transaction-item"
            >
              <b-media no-body>
                <b-media-aside>
                  <b-avatar
                    rounded
                    size="42"
                    variant="light-primary"
                  >
                    <feather-icon
                      v-if="!loader"
                      size="18"
                      :icon="client.type === 'person' ? 'UserIcon' : 'HomeIcon'"
                    />
                  </b-avatar>
                </b-media-aside>
                <b-media-body>
                  <h6
                    id="popover-reactive-1"
                    ref="button"
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="outline-primary"
                    class="transaction-title pointer-name"
                    @mouseover="setclientpopup(client)"
                  >
                    <b-link
                      :to="{ name: 'client-view', params: { id: client.id } }"
                      target="_blank"
                    >{{ (client.name) ? client.name : 'clientName' }}
                    </b-link>
                  </h6>
                  <div><small>{{ client.contact_person }}</small></div>
                  <div v-if="client.address && client.address.place">
                    <small>{{ client.address.place }}</small></div>
                </b-media-body>
              </b-media>
            </div>
          </b-card-body>
          <b-card-header>
            <b-card-title>{{ $t('DEBTIA_DEBTORS') }}</b-card-title>
            <div class="d-flex align-items-center">
              <b-card-title class="text-primary">
                <b-button
                  v-if="isRkiBtnVisible"
                  id="add-case-btn"
                  v-b-modal.modal-manual-rki
                  variant="outline-primary"
                >
                  <span class="text-nowrap">{{ $t('DEBTIA_MANUAL_RKI') }}</span>
                </b-button>
              </b-card-title>
              <b-card-title class="text-primary">
                <b-button
                  id="add-case-btn"
                  v-b-modal.modal-change-debtors
                  variant="primary"
                  class="ml-1"
                >
                  <span class="text-nowrap">{{ $t('DEBTIA_CHANGE') }}</span>
                </b-button>
              </b-card-title>
            </div>
          </b-card-header>

          <b-card-body
            class="casedetails-card-body"
          >
            <div
              v-for="(data,index) in debtors"
              :key="index"
              class="transaction-item"
            >
              <b-media no-body>
                <b-media-aside v-if="data.isMainDebtor === true">
                  <div
                    class="star-icon-box"
                  >
                    <b-avatar
                      rounded
                      size="42"
                      variant="light-primary"
                    >
                      <div
                        class="star"
                      />
                      <feather-icon
                        size="18"
                        :icon="data.debtor_type === 'person' ? 'UserIcon' : 'HomeIcon'"
                      />
                    </b-avatar>
                  </div>
                </b-media-aside>
                <b-media-aside v-else>
                  <b-avatar
                    rounded
                    size="42"
                    variant="light-primary"
                  >
                    <feather-icon
                      size="18"
                      :icon="data.debtor_type === 'person' ? 'UserIcon' : 'HomeIcon'"
                    />
                  </b-avatar>
                </b-media-aside>
                <b-media-body>
                  <div class="d-flex align-items-center">
                    <h6
                      :id="'popover-reactive-debtor-'+data.id"
                      ref="button"
                      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                      variant="outline-primary"
                      :to="{ name: 'debtor-view', params: { id: data.id } }"
                      class="transaction-title pointer-name"
                    >
                      <b-link
                        :to="{ name: 'debtor-view', params: { id: data.id } }"
                        target="_blank"
                      >{{ (data.name) ? data.name : 'debtorName' }}
                      </b-link>
                      <b-badge
                        v-if="data.rkiStatus"
                        :variant="data.rkiStatus && data.rkiStatus === '1' ? 'danger' : 'warning'"
                      >
                        {{ data.rkiStatus && data.rkiStatus === '1' ? $t('DEBTIA_OPEN_RKI_STATUS') : data.rkiStatus && data.rkiStatus === '0' ? $t('DEBTIA_CLOSE_RKI_STATUS') : $t('DEBTIA_RKI_AWAIT') }}
                      </b-badge>
                      <b-badge
                        v-if="data.rkiManualStatus"
                        variant="warning"
                      >
                        {{ data.rkiManualStatus && data.rkiManualStatus === '1' ? $t('DEBTIA_OPEN_MANUAL_RKI_STATUS') : $t('DEBTIA_CLOSE_MANUAL_RKI_STATUS') }}
                      </b-badge>
                    </h6>
                    <b-badge
                      variant="danger"
                      style="margin-left: 5px;"
                    >
                      <feather-icon
                        v-if="data.rkiManualStatus"
                        size="18"
                        icon="XIcon"
                        style="cursor: pointer;"
                        @click="deleteRecord(data.rkiEntryId)"
                      />
                    </b-badge>
                  </div>
                  <div><small>{{ data.contact_person }}</small></div>
                  <div v-if="data.address && data.address.place">
                    <small>{{ data.address.place }}</small></div>
                  <div
                    v-if="data.representative !== null"
                    class="representative-div"
                  >
                    <b-badge variant="primary">
                      {{ $t('DEBTIA_REPRESENTATIVE') }}
                    </b-badge>
                    <h6
                      :id="'popover-reactive-debtor-'+data.id"
                      ref="button"
                      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                      variant="outline-primary"
                      :to="{ name: 'debtor-view', params: { id: data.id } }"
                      class="transaction-title pointer-name"
                    >
                      <b-link
                        :to="{ name: 'debtor-view', params: { id: data.id } }"
                        target="_blank"
                      >{{ (data.name) ? data.name : 'debtorName' }}
                      </b-link>
                      <b-badge
                        v-if="data.rkiStatus"
                        :variant="data.rkiStatus && data.rkiStatus === '1' ? 'danger' : 'warning'"
                      >
                        {{ data.rkiStatus && data.rkiStatus === '1' ? $t('DEBTIA_OPEN_RKI_STATUS') : $t('DEBTIA_CLOSE_RKI_STATUS') }}
                      </b-badge>
                    </h6>
                    <div><small>{{ data.contact_person }}</small></div>
                    <div v-if="data.address && data.address.place">
                      <small>{{ data.address.place }}</small></div>
                    <div
                      v-if="data.representative !== null"
                      class="representative-div"
                    >
                      <b-badge variant="primary">
                        {{ $t('DEBTIA_REPRESENTATIVE') }}
                      </b-badge>
                      <h6
                        :id="'popover-reactive-representative-'+data.id"
                        ref="button"
                        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                        variant="outline-primary"
                        class="transaction-title pointer-name"
                        @mouseover="setrepresentativepopup(data.representative)"
                      >
                        {{ (data.representative.name) ? data.representative.name : 'representativeName' }}
                      </h6>
                      <div
                        v-if="data.representative !== null"
                      ><small>{{ data.representative.company }}</small></div>
                      <div
                        v-if="data.representative !== null"
                      ><small>{{ data.representative.phone }}</small></div>
                    </div>
                  </div>
                </b-media-body>
              </b-media>
            </div>
          </b-card-body>
        </b-overlay>
      </b-card>
      <client-popover
        v-if="client"
        :current-hover-client="currentHoverClient"
      />
      <debtor-popover :debtors="debtors" />
      <representative-popover :debtors="debtors" />
      <change-client-modal
        :case-id="caseId"
        :creditor-id="creditorId"
        :get-debt-case-debtors="caseDebtors"
        :client-debtors-options="clientDebtorsOptions"
        :debtors="debtors"
        :is-installment-plan-active="isClientInstallmentPlanActive"
      />
      <change-debtors-modal
        :case-id="caseId"
        :creditor-id="creditorId"
        :get-debt-case-debtors="caseDebtors"
        :client-debtors-options="clientDebtorsOptions"
        :debtors="debtors"
        :is-installment-plan-active="isDebtorsInstallmentPlanActive"
      />
      <manual-rki-modal
        :debtors="debtors"
      />
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow, BCol, BCard, BCardBody, BMedia, BCardHeader, BCardTitle, BMediaBody, BBadge,
  BMediaAside, BAvatar, BButton, BLink, BOverlay,
} from 'bootstrap-vue'
// import store from '@/store'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'
import axios from '@axios'
import constants from '@/app-configs/constants'
import { EventBus } from '@/event-bus'
import ChangeClientModal from '@/views/cases/details/ChangeClientModal.vue'
import ChangeDebtorsModal from '@/views/cases/details/ChangeDebtorsModal.vue'
import i18n from '@/libs/i18n'
import ClientPopover from './ClientPopWindow.vue'
import DebtorPopover from './DebtorPopover.vue'
import RepresentativePopover from './RepresentativePopover.vue'
import ManualRkiModal from './ManualRkiModal.vue'
// import DragLinks from '../DragLinks.vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BMedia,
    BCardHeader,
    BCardTitle,
    BMediaBody,
    BBadge,
    BMediaAside,
    BAvatar,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    FeatherIcon,
    ClientPopover,
    DebtorPopover,
    RepresentativePopover,
    // DragLinks,
    BButton,
    BLink,
    ChangeClientModal,
    ChangeDebtorsModal,
    ManualRkiModal,
    BOverlay,
  },
  // setup() {
  //   const { fullCaseObject } = store.state['case-details']
  //   return {
  //     fullCaseObject,
  //   }
  // },
  directives: {
    Ripple,
  },
  props: {
    side: {
      type: String,
      required: true,
    },
    customChange: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      identitiesLoader: true,
      loader: true,
      debtors: [],
      currentHoverClient: {
        address: {},
        billing_address: {},
      },
      currentHoverRepresentative: {
        address: {},
      },
      client: {
        address: {},
      },
      clientAddress: [],
      caseId: this.$route.params.id,
      clientDebtorsOptions: [],
      creditorId: 0,
      caseDebtors: [],
      isDebtorsInstallmentPlanActive: false,
      isClientInstallmentPlanActive: false,
      isRkiBtnVisible: false,
    }
  },
  created() {
    EventBus.$on('refreshDebtorsSection', () => {
      this.getDebtors()
    })
    EventBus.$on('refreshClientSection', () => {
      this.getClient()
      this.getDebtors()
    })
  },
  methods: {
    deleteRecord(id) {
      this.$swal({
        title: i18n.t('DEBTIA_CAUTION'),
        text: i18n.t('DEBTIA_DELETE_RECORD_MSG'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: i18n.t('DEBTIA_YES'),
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.deleteRecordAction(id)
        }
      })
    },
    async deleteRecordAction(id) {
      this.loader = true
      const apiTokens = await axios.get(`/rki/delete/${id}`)
      if (apiTokens.status) {
        this.getDebtors()
      }
      this.loader = false
    },
    async fetchInitialData() {
      await this.getClient()
      await this.getDebtors()
    },
    async getDebtorsOptions(id) {
      const url = `/debtor/dropdown?client_id=${id}`
      await axios.get(url).then(response => {
        if (response.status === 200) {
          response.data.data.forEach(element => {
            const objArr = {}
            objArr.value = element.value
            objArr.label = `${element.label.slice(0, 30)}...`
            this.clientDebtorsOptions.push(objArr)
          })
        }
      })
    },
    async getDebtors() {
      const url = `${constants.baseUrlV2}/debt-case/debtors-data/${this.caseId}`
      await axios.get(url).then(response => {
        if (response.status === 200) {
          this.debtors = response.data.data.debtors
          this.caseDebtors = response.data.data.case_debtors
          this.isRkiBtnVisible = response.data.data.allow_manual_rki_button
          this.isDebtorsInstallmentPlanActive = (response.data.data.is_installment_plan_active === 1)
          const obj = {
            email: response.data.data.mainDebtor.email,
            phone: response.data.data.mainDebtor.phone,
          }
          this.identitiesLoader = false
          EventBus.$emit('getMainDebtorInformation', obj)
        }
      })
    },
    async getClient() {
      const caseID = this.$route.params.id
      const url = `${constants.baseUrlV2}/debt-case/client-data/${caseID}`
      await axios.get(url).then(response => {
        if (response.status === 200) {
          this.client = response.data.data.client
          this.creditorId = this.client.id
          this.getDebtorsOptions(this.client.id)
          this.loader = false
          this.isClientInstallmentPlanActive = (response.data.data.is_installment_plan_active === 1)
          EventBus.$emit('setCreditorId', this.client.id)
        }
      })
    },
    setclientpopup(client) {
      this.currentHoverClient = client
      this.currentHoverClientAddress = this.clientAddress
    },
    setrepresentativepopup(representative) {
      this.currentHoverRepresentative = representative
    },
  },
}
</script>

<style lang="scss">
.star-icon-box:before {
    content: '';
}
.star-icon-box {
  position: relative;
  // width: 100px;
  // height: 100px;
  // background-color: #f0f0f0;
  // border: 1px solid #ccc;
  display: flex;
  align-items: center;
  justify-content: center;
}
/* Styles for the star */
.star {
  position: absolute;
  top: 0;
  // left: 0;
  left: -7px;
  top: -8px;;
  width: 20px;
  height: 20px;
  background-color: gold;
  clip-path: polygon(
      50% 0%,
      61% 38%,
      100% 38%,
      68% 59%,
      79% 100%,
      50% 75%,
      21% 100%,
      32% 59%,
      0% 38%,
      39% 38%
    );
  }

.representative-div {
  margin-top: 5px;
  padding-top: 5px;
  border-top: 1px solid #d9d9d9;
}
.badge-light-primary .b-avatar-custom{
    mask-image: unset;
}
</style>
